import { cva } from '@/styled-system/css';

export const alertIconRecipe = cva({
  base: {
    flex: '0 0 auto',
    marginInlineEnd: 'default',
  },
  variants: {
    tone: {
      info: { color: 'Alert.info.icon' },
      critical: { color: 'Alert.critical.icon' },
      success: { color: 'icon.feedback.success.hero-alt' },
      warning: { color: 'Alert.warning.icon' },
    },
  },
});
